import styled from 'styled-components';

export const Wrapper = styled.div`
	margin-right: 20px;
	margin-bottom: 40px;
	background: radial-gradient(
		rgba(255, 255, 255, 0.15) 0%,
		rgba(255, 255, 255, 0) 70%
	);
`;

export const Tile = styled.div`
	height: ${props => props.mobile ? '150px' : '250px'};
	width: 50%;
	margin: 10px 10px 10px 10px;
	padding-top: 10px;
	text-align: center;
	background: url(${props => props.background});
	background-position: center;
	background-size: 100%;
	background-repeat: no-repeat;	
	font-weight: 300;
	transition: transform 0.2s linear;
	display: flex;
	align-items: center;

	& h2 {
		margin-top: -10px;
		padding-top: 2px;
		padding-bottom: 2px;
		font-weight: 300;
		border-top-left-radius: 7px;
		border-top-right-radius: 7px;
		font-size: 25px;
	}

	&:hover {
		cursor: pointer;
		transform: TranslateY(-20px);
		z-index: 999999;
	}

	& span {
		color: transparent; 
		mix-blend-mode: difference;
		font-weight: 900;
		font-size: 4vw;
		text-align: center;
		width: 100%;
	}

	&:hover span {
		opacity: 1;
		transition: color linear 0.7s;
		color: white;
	}
`;

export const Row = styled.div`
	display: flex;
`;


// WEBPACK FOOTER //
// ./src/components/portfolio/components.js